import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Edit3, Save, Loader2, Mail, Phone } from "lucide-react";

const POSITIONS = ["Ponteiro", "Central", "Oposto", "Levantador", "Líbero"];

export default function EditProfileDialog({
  open, onOpenChange, editFirstName, setEditFirstName, editLastName, setEditLastName,
  editPosition, setEditPosition, editPosition2, setEditPosition2,
  editEmail, setEditEmail, editPhone, handlePhoneChange, handleEmailChange,
  emailError, isUpdatingProfile, handleUpdateProfile, t, trigger,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className="bg-card border-border max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-foreground">{t("playerDashboard.editProfile")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label className="text-foreground">{t("login.firstName")}</Label>
              <Input value={editFirstName} onChange={(e) => setEditFirstName(e.target.value)} className="bg-muted border-border" data-testid="edit-first-name" />
            </div>
            <div className="space-y-2">
              <Label className="text-foreground">{t("login.lastName")}</Label>
              <Input value={editLastName} onChange={(e) => setEditLastName(e.target.value)} className="bg-muted border-border" data-testid="edit-last-name" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label className="text-foreground">{t("login.position")}</Label>
              <Select value={editPosition} onValueChange={setEditPosition}>
                <SelectTrigger className="bg-muted border-border" data-testid="edit-position"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {POSITIONS.map((pos) => (<SelectItem key={pos} value={pos}>{pos}</SelectItem>))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label className="text-foreground">{t("login.secondPosition") || "2a Posicao"}</Label>
              <Select value={editPosition2 || "none"} onValueChange={(v) => setEditPosition2(v === "none" ? "" : v)}>
                <SelectTrigger className="bg-muted border-border" data-testid="edit-position2"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">{t("common.none") || "Nenhuma"}</SelectItem>
                  {POSITIONS.filter((p) => p !== editPosition).map((pos) => (<SelectItem key={pos} value={pos}>{pos}</SelectItem>))}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="space-y-2">
            <Label className="text-foreground flex items-center gap-2"><Mail className="h-4 w-4" />{t("login.email")}</Label>
            <Input type="email" value={editEmail} onChange={handleEmailChange} placeholder="email@exemplo.com" className={`bg-muted border-border ${emailError ? "border-red-500" : ""}`} data-testid="edit-email" />
            {emailError && <p className="text-red-400 text-xs">{emailError}</p>}
          </div>
          <div className="space-y-2">
            <Label className="text-foreground flex items-center gap-2"><Phone className="h-4 w-4" />{t("login.phone")}</Label>
            <Input type="tel" value={editPhone} onChange={handlePhoneChange} placeholder="(555) 555-5555" className="bg-muted border-border" maxLength={15} data-testid="edit-phone" />
          </div>
          <Button onClick={handleUpdateProfile} disabled={isUpdatingProfile || !!emailError} className="w-full bg-[#CCFF00] text-black hover:bg-[#CCFF00]/90" data-testid="save-profile-btn">
            {isUpdatingProfile ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}
            {t("common.save")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
